import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Col, Row, Tabs, TabsProps } from "antd";

import AssignableUsers from "../components/AssignableUsers";
import CustomerMapping from "../components/CustomerMapping";
import ExpenseSuppliers from "../components/ExpenseSuppliers";
import { FeatureFlags } from "../hooks/featureFlagsProvider";
import { useAppSelector } from "../store";
import NotFound from "./NotFound";

interface Props {
    envConfig: any;
}

const DEFAULT_TAB = "expense-suppliers";

/**
 * Miner's admin section. More than one page now (FOC-5953), so the tab lives in the URL and each
 * one is linkable.
 */
function MinerAdmin({ envConfig }: Props) {
    const { features } = useContext(FeatureFlags);
    const roles = useAppSelector((state) => state.user?.roles);
    const hasAdmin = roles.includes("Admin");
    const history = useHistory();
    const location = useLocation();

    // The API refuses these endpoints without the Admin role; this only keeps the page itself from
    // being reachable by typing the URL, the way the TFS admin page already does.
    useEffect(() => {
        if (!hasAdmin) {
            history.push("/");
        }
    }, [hasAdmin, history]);

    const items: TabsProps["items"] = [
        {
            key: DEFAULT_TAB,
            label: "Expense Suppliers",
            children: <ExpenseSuppliers envConfig={envConfig} />,
        },
    ];

    if (features?.isAssignToEnabled) {
        items.push({
            key: "assignable-users",
            label: "Assignable Users",
            children: <AssignableUsers />,
        });
    }

    const requested = location.pathname.split("/")[2];
    const activeKey = items.some((item) => item.key === requested) ? requested : DEFAULT_TAB;

    if (!hasAdmin) {
        return null;
    }

    return (
        <Row>
            <Col span={1} />
            <Col span={22} className="container">
                <Tabs activeKey={activeKey} items={items} onChange={(key) => history.push(`/admin/${key}`)} />
            </Col>
            <Col span={1} />
        </Row>
    );
}

function Admin({ envConfig }: Props) {

    switch (envConfig?.appConfig?.theme) {
        case "tfs":
            return <CustomerMapping envConfig={envConfig} />;
        case "miner":
            return <MinerAdmin envConfig={envConfig} />;
        default:
            return <NotFound />;
    }
}

export default Admin;
